module.exports = __webpack_public_path__ + "img/PumpWithVFD.ca750541.png";